import { setDefaultBuildingColor } from "../building_color/building.color.helper";
import { getSidingOrientationOptions } from "../building_material/buildingMaterial.helper";
import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import * as cuComponent from "../../../redux/reducers/building_component/componentReducer";
import * as utils from "../../../redux/reducers/utils";
import centerBuildingsWallOptionsHelpers from "../building_wall/centerBuildingsWallOptions.helpers";
import leanToWallOptionHelpers from "../../lean_building_pricing/lenatoWallOptions.helpers";

import {
	makeDimensionUpdateRight,
	makeDimensionUpdateFront,
	makeDimensionUpdateLeft,
	makeDimensionUpdateBack,
	updateTemplateWidthR,
	updateTemplateWidthB,
	updateTemplateWidthL,
	updateTemplateWidthF
} from "../../lean_building_pricing/leanBuilding.helper";
import { loadDefaultBuilding } from "../load_building/loadBuilding";
import { handlCupolaPositionOnDimensionChange, removeAllCupolas } from "../../building_component/buildingComponent.helper";
import { setWainscotDefault } from "../building_color/wainscotColor.helper";
import { checkRoofPitch } from "../building_config/building.helper";
import { checkLegsDataAccordingtoResponse } from "../../building_component/legs_condition.helper";
import { makeTranslucent } from "../building_config/componentConfig";

const createBuildingStyleChanges = ({
	THREE,
	params,
	const_var,
	utils,
	controls,
	cuBuilding,
	cuComponent,
	updateBreezewayFrameAndStorages,
	ManufacturesDefaultDetails,
	makeDimensionArray,
	makeDimensionUpdateFront,
	makeDimensionUpdateBack,
	makeDimensionUpdateLeft,
	makeDimensionUpdateRight,
	reSelExtEle,
	dynamicWallOptions,
	dynamicWallOptionsForLeanTo,
	hidePriceForGableLeanTos
}) => {
	const buildingTypeChange = (state, val) => {
		hidePriceForGableLeanTos(state);
		const_var.wainscotApiCall = "";
		const_var.manufacturer_discount_label = "";
		const_var.manufacturer_discount_changed = false;
		const_var.edited_manufacturer_discount_label = "";
		const_var.selected_scbracing = "";
		const_var.selected_ecbracing = "";
		const_var.selectedBracingForAddedBuilding = {
			left_lean_end: "",
			left_lean_side: "",
			right_lean_end: "",
			right_lean_side: "",
			front_lean_end: "",
			front_lean_side: "",
			back_lean_end: "",
			back_lean_side: ""
		};
		const_var.isFreeStandingBuilding = false;
		if (state.defaultBuilding == undefined) {
			state.defaultBuilding = 1;
		}
		const_var.surcharge_amount_is_edit = false;
		if (const_var.garageDoorColor != undefined) {
			let colorData = const_var?.garageDoorColor.filter((data) => data.name == "White");
			if (colorData.length == 0) {
				colorData = const_var?.SendAPIBuildingData?.garageDoorColor?.[0];
			} else {
				colorData = colorData[0];
			}
			params.g_d_c_name = colorData?.name;
			params.g_d_c_id = colorData?.id;
			params.g_d_c = colorData?.hex_value?.replace("#", "0x");
		}

		if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
			params.singleSlope = true;
			params.p_w_c_n = false;
		}

		if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
			params.p_r_p = "2";
			params.b_r_p = "212";
		}

		if (state.params.building_type_name.includes("Breezeway") || state.const_var.defaultBuildingImgName == "Breezeway_Building") {
		}
		params.cupola = false;
		params.cupolasize = "";
		const_var.cupolaObj = {};
		const_var.callMesure = false;
		const_var.checkforLeanto = false;
		state.const_var.roof_style = state.c_m_a[state.params.p_b_t].roof_style;
		state.params.frame_length = state.const_var.roofObject[params.p_b_t][params.p_r_s].roof_length != undefined ? state.const_var.roofObject[params.p_b_t][params.p_r_s].roof_length : 0;

		const_var.textureImageForRoofSecond = "";
		const_var.textureImageForRoof = "";
		const_var.textureImageForRoofL = "";
		const_var.textureImageForRoofR = "";

		let fLength = params.p_d;
		let fWidth = params.p_w;
		params.add_front_lean && (fLength += params.leanF_p_w);
		params.add_back_lean && (fLength += params.leanB_p_w);
		params.add_left_lean && (fWidth += params.lean_p_w);
		params.add_right_lean && (fWidth += params.leanR_p_w);
		let diag = new THREE.Vector3(fLength, fWidth, params.p_h).length();
		if (const_var.controls) const_var.controls.maxDistance = diag >= 100 ? 500 : diag * 6;

		makeTranslucent(controls.isCheckActiveTab, params.activeWall, params.is_translusant, const_var.scene);
		reSelExtEle(state, true);
		cuComponent.removeAlltheComponent();
		removeAllCupolas();
		makeDimensionArray(state);
		cuBuilding.uUdDCB();
		cuBuilding.uUdD();
		cuBuilding.leanuUdD();

		const_var.CheckDoorForEdit = false;
		cuBuilding.BuildingUpdate(true, "");
		cuBuilding.UpdateFrontLean();
		cuBuilding.UpdateLeftLean();
		cuBuilding.UpdateRightLean();
		cuBuilding.UpdateBackLean();

		window.twoDMapReqPng = undefined;
		window.twoDMapReqSvg = undefined;
		window.twoDMapAutoPng = undefined;
		window.twoDMapAutoSvg = undefined;
		const_var.twoDImageObj = [];
		const_var.ShowTwodLayoutDefault = false;
		if (
			const_var.hasDoublelegshow === true ||
			(const_var.a_p_d_a.side != undefined && Object.keys(const_var.a_p_d_a.side).length > 0 && const_var.a_p_d_a.side[0].lift_type != undefined && const_var.a_p_d_a.side[0].lift_type != "") ||
			(const_var.a_p_d_a.addons_width && const_var.a_p_d_a.addons_width.length > 0 && const_var.a_p_d_a.addons_width[0].end_cross_bracing != undefined && const_var.a_p_d_a.addons_width[0].end_cross_bracing != 0) ||
			(const_var.a_p_d_a.side_cross_bracing != undefined && const_var.a_p_d_a.side_cross_bracing.length > 0 && const_var.a_p_d_a.side_cross_bracing[0].is_default != "no")
		) {
			const_var.commonBuildingFlag.center.buildingHeight = true;
		}

		if (state.params.add_left_lean == true && state.params.add_right_lean == true) {
			const_var.navEventKey.leanto = "leftLean";
		} else if (state.params.add_right_lean == true && state.params.leanStyle.right !== "gable") {
			const_var.navEventKey.leanto = "rightLean";
		} else if (state.params.add_left_lean == true && state.params.leanStyle.left === "gable") {
			const_var.navEventKey.leanto = "rightLean";
		} else {
			const_var.navEventKey.leanto = "leftLean";
		}
		if (state.c_m_a[params.p_b_t]?.wainscot_details?.length > 0 && state.const_var.selSidingOption != "metal" && const_var.alertUsedFor == "") {
			setWainscotDefault(state.c_m_a, params, state.const_var.color);
		}
	};

	const buildingStyleChange = (state, val, shouldNotResetisLTBuildingFlag) => {
		const_var.commonBuildingFlag.center.buildingHeightChk = false;
		params.isBuildingStyleChange = true;
		const_var.dealer_discount_label = "";
		const_var.manufacturer_discount_label = "";
		state.params.ShowLeanRecord = false;
		state.const_var.thirdPartyComponent.tax.garage = {};
		state.const_var.thirdPartyComponent.tax.insulation = {};
		state.const_var.thirdPartyComponent.commissions.garage = {};

		state.const_var.thirdPartyComponent.commissions.insulation = {
			center: {},
			left: {},
			right: {},
			front: {},
			back: {}
		};
		state.const_var.thirdPartyComponent.surcharge.garage = {};
		state.const_var.thirdPartyComponent.surcharge.insulation = {
			center: {},
			left: {},
			right: {},
			front: {},
			back: {}
		};

		if (const_var.crmSetting.is_Action_url != "order/save") {
			const_var.order_extra_items = {
				job_site_level: "",
				inside_city: "",
				installation_ready: "",
				surface_level: "",
				electricity: "",
				welded_spacer: "no",
				notched_lip: "no",
				space_around_building: "no",
				site_clear_obstacle: "no",
				order_permit_fee: const_var.order_extra_items["order_permit_fee"],
				permit: params.m_s_n == 67 ? "cust_verify" : "yes", //SE3-T1457
				includeIn: "",
				equipment_rental: 0,
				document_fee: const_var.order_extra_items["document_fee"],
				order_processing_fee: const_var.order_extra_items["order_processing_fee"],
				surchargeFees: const_var.order_extra_items["surchargeFees"],
				delivery_fee: 0,
				engineer_drawings: 0,
				freight: 0,
				extra_labour: const_var.order_extra_items["extra_labour"],
				labor_fee_on: const_var.order_extra_items["labor_fee_on"],
				labor_per_type: const_var.order_extra_items["labor_per_type"],
				processing_fee: 0,
				concrete_work: 0,
				ground_work: 0,
				grvy_value: 0,
				has_grvy: 0,
				pdf_price_breakdown: "0",
				dont_show_processing_fee_pdf: 1,
				engineer_drawings_name: ""
			};
		}

		if (const_var.card_processing_fee != undefined && Object.keys(const_var.card_processing_fee).length > 0) {
			const_var.order_extra_items.dont_show_processing_fee_pdf = const_var.card_processing_fee.add_in == "invoice" ? 2 : 1;
		}
		const_var.BuildingPriceArrar["surcharge_amount"] = 0;
		if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"] !== undefined && const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined) {
			const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].is_edit = undefined;
		}
		const_var.surcharge_amount_is_edit = false;
		const_var.order_extra_items["surchargeFees"] = 0;
		cuComponent.removeAlltheComponent();
		params.trimkit = params.chain_hoist = params.header_seal = params.certified_door = params.automatic_openers = params.insulated = params.motor = params.threshold = false;
		Object.keys(params).map((e) => {
			if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price")) {
				let prop = e.replace("entry_", "");
				params[prop] = false;
			}
		});
		const_var.lNTBuildingData = {
			additionalFeaturesArray: { centerBuilding: [], left: [], right: [], front: [], back: [] },
			ExtraItemsFeaturesArray: { centerBuilding: [], left: [], right: [], front: [], back: [] },
			extraAddOnItemsArray: { centerBuilding: [], left: [], right: [], front: [], back: [] },
			ExtraItemsFeaturesArrayForOverhangComputation: { centerBuilding: [], left: [], right: [], front: [], back: [] },
			ExtraItemsFeaturesQuantityArray: { centerBuilding: [], left: [], right: [], front: [], back: [] },
			certificate: { centerBuilding: [], left: [], right: [], front: [], back: [] },
			updatePriceDataElements: { centerBuilding: {}, left: {}, right: {}, front: {}, back: {} }
		};
		const_var.isLNTBuildingIsCustom = false;
		params.extra_notes = "";
		params.activeWall = "c_b_f_w";
		state.doorWindowIconsPos = [];
		state.cupolaEditIconsPos = [];
		params.p_e_i = "";
		params.p_e_l = params.lean_p_e_l = params.leanR_p_e_l = params.leanF_p_e_l = params.leanB_p_e_l = false;
		const_var.hasDoublelegName = "";
		params.o_v_h_n_g = false;
		params.o_v_h_n_g_e = false;
		params.fourth_center_cost = false;
		params.isDefaultfourFeet = false;
		const_var.callMesure = false;
		const_var.inputs = [];
		const_var.Componentinputs = [];
		const_var.ExtraItemsFeaturesArray = [];
		const_var.ExtraItemsFeaturesQuantityArray = [];
		const_var.extraAddOnItemsArray = [];
		const_var.cupolaObj = {};
		removeAllCupolas();

		state.const_var.UpdatedPriceData = {
			roof_style_price_changed: true,
			lifttype_price_changed: true,
			cupola_price_changed: true,
			width_price_changed: true,
			length_price_changed: true,
			height_price_changed: true,
			left_wall_price_changed: true,
			right_wall_price_changed: true,
			right_wall_cut_panel_price_changed: true,
			left_wall_cut_panel_price_changed: true,
			front_wall_price_changed: true,
			back_wall_price_changed: true,
			certificate_price_changed: true,
			common_width_changed: true,
			common_length_changed: true,
			common_height_changed: true,
			utility_price_changed: true,
			front_utility_price_changed: true,
			wainscot_price_changed: true,
			connection_fee_end_changed: true,
			connection_fee_side_changed: true,
			roof_pitch_price_changed: true,
			lifttype_price_changed: true,
			left_lean_roof_style_price_changed: true,
			left_lean_width_price_changed: true,
			left_lean_length_price_changed: true,
			left_lean_height_price_changed: true,
			left_lean_left_wall_price_changed: true,
			left_lean_front_wall_price_changed: true,
			left_lean_back_wall_price_changed: true,
			left_lean_certificate_price_changed: true,
			left_lean_utility_price_changed: true,
			left_lean_roof_pitch_price_changed: true,
			right_lean_roof_style_price_changed: true,
			right_lean_width_price_changed: true,
			right_lean_length_price_changed: true,
			right_lean_height_price_changed: true,
			right_lean_right_wall_price_changed: true,
			right_lean_front_wall_price_changed: true,
			right_lean_back_wall_price_changed: true,
			right_lean_certificate_price_changed: true,
			right_lean_utility_price_changed: true,
			right_lean_roof_pitch_price_changed: true,
			front_lean_roof_style_price_changed: true,
			front_lean_width_price_changed: true,
			front_lean_length_price_changed: true,
			front_lean_height_price_changed: true,
			front_lean_left_wall_price_changed: true,
			front_lean_front_wall_price_changed: true,
			front_lean_back_wall_price_changed: true,
			front_lean_certificate_price_changed: true,
			front_lean_utility_price_changed: true,
			front_lean_roof_pitch_price_changed: true,
			back_lean_roof_style_price_changed: true,
			back_lean_width_price_changed: true,
			back_lean_length_price_changed: true,
			back_lean_height_price_changed: true,
			back_lean_left_wall_price_changed: true,
			back_lean_front_wall_price_changed: true,
			back_lean_back_wall_price_changed: true,
			back_lean_certificate_price_changed: true,
			back_lean_utility_price_changed: true,
			back_lean_roof_pitch_price_changed: true,
			color_price_changed: true,
			down_payment_type: "per",
			down_payment_discount_type: "per",
			discount_type: "per",
			left_front_wrap_connection_fee_changed: true,
			right_front_wrap_connection_fee_changed: true,
			right_back_wrap_connection_fee_changed: true,
			left_back_wrap_connection_fee_changed: true,
			front_lean_insulation_price_changed: true,
			left_lean_insulation_price_changed: true,
			right_lean_insulation_price_changed: true,
			back_lean_insulation_price_changed: true,
			wall_color_price_changed: true,
			roof_color_price_changed: true,
			trim_color_price_changed: true,
			wainscot_price_changed: true,
			truss_price_changed: true,
			left_lean_right_wall_price_changed: true,
			right_lean_left_wall_price_changed: true,
			front_lean_right_wall_price_changed: true,
			back_lean_right_wall_price_changed: true,
			siding_material_price_changed: true,
			frontLean_truss_price_changed: true,
			backLean_truss_price_changed: true,
			rightLean_truss_price_changed: true,
			leftLean_truss_price_changed: true,
			common_left_lean_length_changed: true,
			common_right_lean_length_changed: true,
			common_front_lean_length_changed: true,
			common_back_lean_length_changed: true,
			common_left_lean_width_changed: true,
			common_right_lean_width_changed: true,
			common_front_lean_width_changed: true,
			common_back_lean_width_changed: true
		};
		state.defaultBuilding = params.p_b_t; //val;
		state.checkedBuildingType = state.checkedBuildingType == undefined ? params.p_b_t : state.checkedBuildingType;

		if (state.const_var.defaultBuildingArr[state.defaultBuilding] != undefined && state.const_var.defaultBuildingArr[state.defaultBuilding].other_building_id.split(",").length == 1) {
			state.OlddefaultBuilding = val;
		}
		if (state.const_var.defaultBuildingArr[state.defaultBuilding] != undefined && state.const_var.defaultBuildingArr[state.defaultBuilding].other_building_id.split(",").length > 1) {
			state.OlddefaultBuilding = val;
		}
		const_var.BuldingIDforReset = state.defaultBuilding;
		if (state.const_var.defaultBuildingArr[state.defaultBuilding] != undefined && state.const_var.defaultBuildingArr[state.defaultBuilding].oldBuildingID != undefined) {
			state.OlddefaultBuilding = state.const_var.defaultBuildingArr[state.defaultBuilding].oldBuildingID;
			const_var.BuldingIDforReset = state.const_var.defaultBuildingArr[state.defaultBuilding].oldBuildingID;
		}
		const_var.isCBSelected = true;
		const_var.selectedLeanType = "";
		if (!(shouldNotResetisLTBuildingFlag === true)) {
			const_var.isLTBuilding =
				state.const_var.defaultBuildingArr?.[state.defaultBuilding]?.image_name?.includes("shape") || state.const_var.defaultBuildingArr?.[state.defaultBuilding]?.image_name?.includes("Front_to_Back")
					? true
					: false;
		}

		const_var.BuildingLRoofPitch = {};
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_utility_price_changed = true;
		state.params.gauge_val_check = false;
		state.params.gauge_val = 14;
		state.params.p_c_p_l = state.params.p_c_p_r = state.params.p_c_p_f = false;
		state.params.a_c_p_l = state.params.a_c_p_r = state.params.a_c_p_f = false;
		state.const_var.b_r_p_a = [];
		state.const_var.b_r_p_l_to_a = [];
		state.const_var.BuildingRoofPitch = [];
		state.params.p_a_g_r_u_d = "Select";
		state.params.f_r_m_o_t = "Select";
		state.params.f_r_m_o_t1 = "Select";
		state.params.p_w_cc = "Select";
		state.params.p_d_c = "Select";
		const_var.leanto = [];
		const_var.ExtraItemsFeaturesArray = [];
		const_var.additionalFeaturesArray = [];
		const_var.additionalFeaturesArrayWithPosition = [];
		const_var.ExtraItemsFeaturesQuantityArray = [];
		const_var.extraAddOnItemsArray = [];
		params.b_r_p = "312";
		params.p_r_p = 3;
		params.b_l_t_r_p = params.b_l_t_r_pR = "2";
		params.p_i_s = "1";
		state.isFullyOpenedCheckedForLeftLeanTo = false;
		state.isFullyOpenedCheckedForRightLeanTo = false;
		state.isFullyEnclosedChecked = false;
		state.isFullyEnclosedCheckedForLeftLeanTo = false;
		state.isFullyEnclosedCheckedForRightLeanTo = false;
		state.params.p_w_c_n = false;
		const_var.checkVerticalCheckBox = false;
		state.params.isShowCenter = false;
		state.params.newtrussType = "";
		state.params.leanStyle = { left: "standard", right: "standard", front: "standard", back: "standard" };

		params.singleSlope = false;
		params.isBreezeway = false;
		params.p_i_o = "0";
		state.params.selectedInsulationId = 0;
		params.p_f_i = params.p_r_o = false;
		params.p_c_i = false;
		const_var.showDefaultInsullation = false;
		const_var.showInsulation = true;

		params.insulation = {
			center: { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false, custom: false },
			frontLean: { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false, custom: false },
			leftLean: { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false, custom: false },
			rightLean: { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false, custom: false },
			backLean: { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false, custom: false }
		};

		const_var.insulationArrayForLeantoLeft = [];
		const_var.insulationArrayForLeantoRight = [];
		const_var.insulationArrayForLeantoFront = [];
		const_var.insulationArrayForLeantoBack = [];

		const_var.insulationJson = [];
		state.params.add_full_lean_porch = false;
		state.params.add_left_front_lean_porch = false;
		state.params.add_left_back_lean_porch = false;
		state.params.add_right_front_lean_porch = false;
		state.params.add_right_back_lean_porch = false;

		state.params.add_left_lean = false;
		state.params.add_right_lean = false;
		state.params.add_front_lean = false;
		state.params.add_back_lean = false;

		state.params.lean_p_pos = 0;
		state.params.leanR_p_pos = 0;
		state.params.leanF_p_pos = 0;
		state.params.leanB_p_pos = 0;

		state.isFullyOpenedCheckedForFrontLeanTo = false;
		state.isFullyOpenedCheckedForBackLeanTo = false;
		state.isFullyOpenedCheckedForLeftLeanTo = false;
		state.isFullyOpenedCheckedForRightLeanTo = false;
		const_var.setSidesEndsWallOption = "open";
		params.add_wrap_around_porch = false;

		state.params.add_storage_check_front = false;
		state.params.p_c_a_f_l_w = false;
		state.params.p_b_c_b_f_l = "Open";
		state.params.p_b_c_b_f_b = "Open";
		state.params.p_b_c_b_f_f = "Open";
		state.params.b_f_l_t_f = "Open";
		state.params.b_f_l_t_l = "Open";
		state.params.b_f_l_t_r = "Open";

		state.params.add_storage_check_back = false;
		state.params.p_c_a_b_l_w = false;
		state.params.p_b_c_b_b_l = "Open";
		state.params.p_b_c_b_b_f = "Open";
		state.params.p_b_c_b_b_b = "Open";
		state.params.b_b_l_t_f = "Open";
		state.params.b_b_l_t_l = "Open";
		state.params.b_b_l_t_r = "Open";

		state.params.add_storage_check = false;
		state.params.p_c_a_l_l_w = false;
		state.params.p_b_c_b_l_f = "Open";
		state.params.p_b_c_b_l_b = "Open";
		state.params.p_b_c_b_l = "Open";
		state.params.b_l_l_t_l = "Open";
		state.params.b_l_l_t_b = "Open";
		state.params.b_l_l_t_f = "Open";

		state.params.add_storage_check_right = false;
		state.params.p_c_a_r_l_w = false;
		state.params.p_b_c_b_r_f = "Open";
		state.params.p_b_c_b_r_b = "Open";
		state.params.p_b_c_b_r = "Open";
		state.params.b_r_l_t_r = "Open";
		state.params.b_r_l_t_b = "Open";
		state.params.b_r_l_t_f = "Open";
		state.params.b_r_l_t_l = "Open";

		state.params.cB_addStorage_check_left = false;
		state.params.cB_addStorage_check_right = false;
		state.params.cB_addStorage_check_right_utility = false;
		state.params.cB_addStorage_check_left_utility = false;
		state.params.add_storage_check_front = false;
		state.params.add_storage_check_back = false;
		state.params.add_storage_check_right = false;
		params.cB_addStorage_check_both_with_back = false;
		params.cB_addStorage_check_both = false;
		state.params.nostorage = true;

		state.isFullyOpenedCheckedForFrontLeanTo = true;
		state.isFullyOpenedCheckedForBackLeanTo = true;
		state.isFullyEnclosedCheckedForFrontLeanTo = false;
		state.isFullyEnclosedCheckedForBackLeanTo = false;
		params.cupola = false;
		params.cupolasize = "";
		params.is_translusant = false;

		params.endStoragePositionZ = 0;
		params.leftLeanStoragePosition = 0;
		params.rightLeanStoragePosition = 0;
		params.frontLeanStoragePosition = 0;
		params.backLeanStoragePosition = 0;

		loadDefaultBuilding(state, "", val);
		buildingTypeChange(state, params.p_b_t);
	};

	const roofStyleChange = (state, val, bool, groove, chkEdit) => {
		const_var.isShowAlert = false;

		state.holdPreviousRoofStyle = state.params.p_r_s;
		state.holdCurrentRoofStyle = state.const_var.roof_style[val].roof_id;
		state.params.p_r_s = state.const_var.roof_style[val].roof_id;
		state.params.frame_length = state.const_var.roof_style[val].roof_length != undefined ? state.const_var.roof_style[val].roof_length : 0;
		let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height;
		if (state.params.p_h > isMaxHeight) {
			state.params.p_h = isMaxHeight;
		}

		if (const_var.TypeEnum[state.params.p_r_s] == "Regular" && const_var.b_o_J_1[params.p_b_t] == "Custom Buildings" && params.p_w > 30) {
			params.p_w = 12;
		}
		if (state.const_var.arrayendLengthRoof != undefined && state.params.p_d > state.const_var.arrayendLengthRoof[params.p_r_s] && "Vertical" != state.const_var.TypeEnum[state.params.p_r_s]) {
			state.params.p_r_s = 3;
			for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
				if (const_var.roof_style[i].roof_id == state.params.p_r_s) {
					state.params.p_r_s = state.const_var.roof_style[i].roof_id;
					state.params.frame_length = state.const_var.roof_style[i].roof_length != undefined ? state.const_var.roof_style[i].roof_length : 0;
				}
			}
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofStyleLength";
		}
		if (const_var.crmSetting.is_Edit != true) {
			utils.update26GAUpgradePrice();
		}
		if (state.params.p_r_s == "1") {
			state.params.o_v_h_n_g = false;
			state.params.o_v_h_n_g_e = false;
			state.const_var.isOverhang = {
				end: {
					isChecked: false,
					selected: "",
					size: 0.5
				},
				side: {
					isChecked: false,
					selected: "",
					size: 0.5
				},
				both: {
					isChecked: false,
					selected: "",
					size: 0.5
				}
			};
			let ExtraItemsFeaturesArray = state.const_var.ExtraItemsFeaturesArray;
			if (const_var.isLTBuilding) {
				ExtraItemsFeaturesArray = state.const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding;
			}

			if (ExtraItemsFeaturesArray && ExtraItemsFeaturesArray.length > 0) {
				ExtraItemsFeaturesArray.forEach((item, idx) => {
					if ((item && item.name != undefined && item.name == "overhang") || (typeof item?.sheet_name === "string" && item.sheet_name.toLowerCase().includes("overhang"))) {
						item["is_checked"] = false;
						item["is_edit"] = false;
						item["is_included"] = false;
					}
				});
			}

			if (state.const_var.selSidingOption != "metal") {
				if (state.const_var.additionalFeaturesArray && state.const_var.additionalFeaturesArray?.length > 0) {
					state.const_var.additionalFeaturesArray.forEach((item) => {
						if (item?.additional_feature != undefined && item.additional_feature?.toLowerCase()?.trim() == "colored screws") {
							item["is_checked"] = false;
							item["is_edit"] = false;
							item["is_disabled"] = false;
						}
					});
				}
			}
		}

		if (state.const_var.alertUsedFor != "RoofStyleLength" && state.const_var.selSidingOption != "metal" && const_var.TypeEnum[state.params.p_r_s] == "Regular" && params.m_s_n != "12") {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RegularRoofStyleTextureChange";
			state.params.p_v_w = false;
			state.params.wallTexture = "none";
			state.params.wainscotTexture = "none";
			let previousSiding = structuredClone(state.const_var.selSidingOption);
			state.const_var.selSidingOption = "metal";
			state.params.wallOrientation = "horizontal";
			state.const_var.selSidingObj = {
				name: "metal",
				label: "Metal",
				price_type: "$",
				price_of: [],
				panel_price_from: ["vertical"],
				panel_orientation: ["horizontal", "vertical"],
				cost: 0
			};
			state.const_var.sidingOrientationOptions = getSidingOrientationOptions();

			let tempSidingColorObj = state.const_var.color.filter((val) => val.sheet_name != undefined && val.sheet_name.toLowerCase() == state.const_var.selSidingOption.toLowerCase());
			if (tempSidingColorObj.length > 0) {
				let isSelWallClrExsist = tempSidingColorObj.find(
					(val) => val.sheet_name != undefined && val.sheet_name.toLowerCase() == state.const_var.selSidingOption.toLowerCase() && state.params.p_w_c == val.hex_value.replace("#", "0x")
				);
				if (isSelWallClrExsist || tempSidingColorObj.length) {
					state.params.p_w_c_name = isSelWallClrExsist != undefined && isSelWallClrExsist.name ? isSelWallClrExsist.name : tempSidingColorObj[0].name;
					state.params.p_w_c = isSelWallClrExsist != undefined && isSelWallClrExsist.hex_value ? isSelWallClrExsist.hex_value.replace("#", "0x") : tempSidingColorObj[0].hex_value.replace("#", "0x");
					state.params.p_w_c_id = isSelWallClrExsist != undefined && isSelWallClrExsist.id ? isSelWallClrExsist.id : tempSidingColorObj[0].id;
					let colorObj = isSelWallClrExsist != undefined ? isSelWallClrExsist : tempSidingColorObj[0];
					if (tempSidingColorObj != undefined && colorObj.image_name) {
						params.wallTexture = colorObj.image_name.split(".")[0];
						const_var.selSidingOption = colorObj.sheet_name;
						if (params.wallTexture == "none" || params.wallTexture == "vertical") {
							const_var.selSidingOption = "metal";
							state.params.wallOrientation = params.wallTexture == "none" ? "horizontal" : "vertical";
						}
					}

					state.const_var.post_data.building.wall_color_price = 0;

					state.const_var.UpdatedPriceData.wall_color_price_changed = true;
				}

				if (state.params.p_w_c_n == true) {
					let isSelWainscotClrExsist = tempSidingColorObj.find(
						(val) => val.sheet_name != undefined && val.sheet_name.toLowerCase() == state.const_var.selSidingOption.toLowerCase() && state.params.p_w_c_c == val.hex_value.replace("#", "0x")
					);
					if (isSelWainscotClrExsist || tempSidingColorObj.length) {
						state.params.p_w_c_c_name = isSelWainscotClrExsist != undefined && isSelWainscotClrExsist.name ? isSelWainscotClrExsist.name : tempSidingColorObj[0].name;
						state.params.p_w_c_c =
							isSelWainscotClrExsist != undefined && isSelWainscotClrExsist.name ? isSelWainscotClrExsist.hex_value.replace("#", "0x") : tempSidingColorObj[0].hex_value.replace("#", "0x");
						state.params.p_w_c_c_id = isSelWainscotClrExsist != undefined && isSelWainscotClrExsist.name ? isSelWainscotClrExsist.id : tempSidingColorObj[0].id;
					}
				}
			}
		}
		if (chkEdit != "edit") {
			setWainscotDefault(const_var.c_m_a, params, const_var.color);
			const_var.UpdatedPriceData.roof_style_price_changed = true;
			const_var.UpdatedPriceData.front_wall_price_changed = true;
			const_var.UpdatedPriceData.back_wall_price_changed = true;
			const_var.UpdatedPriceData.left_wall_price_changed = true;
			const_var.UpdatedPriceData.right_wall_price_changed = true;
			const_var.UpdatedPriceData.wainscot_price_changed = true;

			const_var.UpdatedPriceData.roof_color_price_changed = true;
			const_var.UpdatedPriceData.wall_color_price_changed = true;
			const_var.UpdatedPriceData.trim_color_price_changed = true;
			const_var.UpdatedPriceData.lifttype_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.UpdatedPriceData.truss_price_changed = true;
			const_var.UpdatedPriceData.frontLean_truss_price_changed = true;
			const_var.UpdatedPriceData.backLean_truss_price_changed = true;
			const_var.UpdatedPriceData.rightLean_truss_price_changed = true;
			const_var.UpdatedPriceData.leftLean_truss_price_changed = true;
		}
		if (!const_var.isTBSOldQuotesForVerticalRoof && params.m_s_n == 13 && params.p_r_s !== 3 && (params.add_front_lean || params.add_back_lean)) {
			params.p_r_s = state.holdPreviousRoofStyle;
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "nonVerticalRoofStyleForTubulerBuildingMnf";
		}
		const_var.checkLoadDefaultBuildingRespone = bool == true ? true : false;

		const_var.textureImageForRoofSecond = "";
		const_var.textureImageForRoof = "";
		const_var.textureImageForRoofL = "";
		const_var.textureImageForRoofR = "";

		if (const_var.DistanceArr[params.p_b_t][params.p_r_s] == undefined) {
			const_var.DistanceArr[params.p_b_t][params.p_r_s] = params.isDefaultfourFeet || params.fourth_center_cost ? 4 : 5;
		}

		makeDimensionArray(state);

		if (state.params.p_r_s == 1) {
			const isSelecedHeight = const_var.buildingHeightArray.find((height) => height.value == params.p_h);
			if (isSelecedHeight == undefined) {
				state.params.p_r_s = state.holdPreviousRoofStyle;
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "regularRoofStyleHeight";
				makeDimensionArray(state);
			}
		}

		let heritageEditCase =
			const_var.crmSetting.is_Edit == true && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && const_var.editAPIDataByResponse != undefined && const_var.editAPIDataByResponse.data != undefined;

		let lowerHeightOfFreeStanding =
			const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
				? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
				: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12);

		if ((params.singleSlope != true && const_var.crmSetting.is_Edit != true && params.m_s_n == 153 && (params.p_r_s == 2 || params.p_r_s == 1) && params.p_h > 10) || (heritageEditCase == true && params.p_h > 10)) {
			if (const_var.insulationPriceJson?.insulation_wall != undefined && Object.keys(const_var.insulationPriceJson.insulation_wall).length > 0) {
				const_var.insulationPriceJson.insulation_wall = {};
			}

			params.insulation.center.insulationId = 0;

			params.insulation.center.isCheked = false;

			params.insulation.center.showInsulationOptions = false;
			params.insulation.center.roofOnly = params.insulation.center.insulationId !== 0 ? true : false;
			params.insulation.center.fullBuilding = params.insulation.center.roofOnly ? false : params.insulation.center.fullBuilding;
			params.insulation.center.custom = params.insulation.center.roofOnly || params.insulation.center.fullBuilding ? false : params.insulation.center.custom;

			const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;

			if (params.add_front_lean == true && params.insulation["frontLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.leanF_p_h > 10) {
				params.insulation["frontLean"].isCheked = false;
				params.insulation["frontLean"].insulationId = 0;

				params.insulation["frontLean"].showInsulationOptions = false;
				params.insulation["frontLean"].roofOnly = params.insulation["frontLean"].insulationId !== 0 ? true : false;
				params.insulation["frontLean"].fullBuilding = params.insulation["frontLean"].roofOnly ? false : params.insulation["frontLean"].fullBuilding;
				params.insulation["frontLean"].custom = params.insulation["frontLean"].roofOnly || params.insulation["frontLean"].fullBuilding ? false : params.insulation["frontLean"].custom;
			}

			// ########### Back lean ##############
			if (params.add_back_lean == true && params.insulation["backLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.leanB_p_h > 10) {
				params.insulation["backLean"].isCheked = false;
				params.insulation["backLean"].insulationId = 0;

				params.insulation["backLean"].showInsulationOptions = false;
				params.insulation["backLean"].roofOnly = params.insulation["backLean"].insulationId !== 0 ? true : false;
				params.insulation["backLean"].fullBuilding = params.insulation["backLean"].roofOnly ? false : params.insulation["backLean"].fullBuilding;
				params.insulation["backLean"].custom = params.insulation["backLean"].roofOnly || params.insulation["backLean"].fullBuilding ? false : params.insulation["backLean"].custom;
			}

			// ########### Right lean ##############
			if (params.add_right_lean == true && params.insulation["rightLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.leanR_p_h > 10) {
				params.insulation["rightLean"].isCheked = false;
				params.insulation["rightLean"].insulationId = 0;

				params.insulation["rightLean"].showInsulationOptions = false;
				params.insulation["rightLean"].roofOnly = params.insulation["rightLean"].insulationId !== 0 ? true : false;
				params.insulation["rightLean"].fullBuilding = params.insulation["rightLean"].roofOnly ? false : params.insulation["rightLean"].fullBuilding;
				params.insulation["rightLean"].custom = params.insulation["rightLean"].roofOnly || params.insulation["rightLean"].fullBuilding ? false : params.insulation["rightLean"].custom;
			}

			// ########### Left lean ##############

			if (params.add_left_lean == true && params.insulation["leftLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.lean_p_h > 10) {
				params.insulation["leftLean"].isCheked = false;
				params.insulation["leftLean"].insulationId = 0;

				params.insulation["leftLean"].showInsulationOptions = false;
				params.insulation["leftLean"].roofOnly = params.insulation["leftLean"].insulationId !== 0 ? true : false;
				params.insulation["leftLean"].fullBuilding = params.insulation["leftLean"].roofOnly ? false : params.insulation["leftLean"].fullBuilding;
				params.insulation["leftLean"].custom = params.insulation["leftLean"].roofOnly || params.insulation["leftLean"].fullBuilding ? false : params.insulation["leftLean"].custom;
			}
		}

		if (
			params.singleSlope == true &&
			((const_var.crmSetting.is_Edit != true && params.m_s_n == 153 && (params.p_r_s == 2 || params.p_r_s == 1) && lowerHeightOfFreeStanding > 10) || (heritageEditCase == true && lowerHeightOfFreeStanding > 10))
		) {
			// params.p_i_o = 0;
			params.insulation.center.insulationId = 0;

			params.insulation.center.isCheked = false;

			params.insulation.center.showInsulationOptions = false;
			params.insulation.center.roofOnly = params.insulation.center.insulationId !== 0 ? true : false;
			params.insulation.center.fullBuilding = params.insulation.center.roofOnly ? false : params.insulation.center.fullBuilding;
			params.insulation.center.custom = params.insulation.center.roofOnly || params.insulation.center.fullBuilding ? false : params.insulation.center.custom;

			const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
		}

		dynamicWallOptions(state);
		dynamicWallOptionsForLeanTo(state);
		state.const_var.c_m_a = state.c_m_a;
		if (params.add_front_lean) {
			makeDimensionUpdateFront(state);
		}
		if (params.add_back_lean) {
			makeDimensionUpdateBack(state);
		}
		if (params.add_left_lean) {
			makeDimensionUpdateLeft(state);
		}
		if (params.add_right_lean) {
			makeDimensionUpdateRight(state);
		}

		if (const_var.isDataWithlegCut == false) {
		}
		cuBuilding.CheckLegsByResponse(state);
		if (
			const_var.crmSetting.is_Edit == true &&
			const_var.UpdatedPriceData.height_price_changed == undefined &&
			const_var.editAPIDataByResponse.data != undefined &&
			const_var.editAPIDataByResponse.data.request_data.building !== undefined &&
			const_var.editAPIDataByResponse.data.request_data.building.roof_style != undefined
		) {
			if (const_var.editAPIDataByResponse.data.request_data.building.roof_style != params.p_r_s) {
				const_var.UpdatedPriceData.height_price_changed = true;
			} else {
				const_var.UpdatedPriceData.height_price_changed = undefined;
			}
		} else {
			const_var.UpdatedPriceData.height_price_changed = true;
		}

		if ((state.params.p_r_s != 3 || (!state.params.p_v_w && state.params.p_r_s == 3)) && ManufacturesDefaultDetails.AMERICAN_STEEL_CARPORTS.id == params.selectedManufactureId) {
			state.params.p_f_i = false;
			state.params.p_r_o = state.params.p_r_s == 3 ? state.params.p_r_o : false;
			state.params.p_c_i = false;
		}

		const_var.UpdatedPriceData.height_price_changed = const_var.crmSetting.is_Edit == true && const_var.UpdatedPriceData.height_price_changed == undefined ? undefined : true;

		if (const_var.crmSetting.is_Edit != true) {
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		}
		cuBuilding.BuildingUpdate(true, "");
		if (params.isBreezeway && chkEdit != "edit") updateBreezewayFrameAndStorages({ option: "buildingHeight" }, undefined, Number(params.p_h));
		if (params.cupola) handlCupolaPositionOnDimensionChange("roofPitch");
		if (params.add_front_lean == true) cuBuilding.UpdateFrontLean();
		if (params.add_left_lean == true) cuBuilding.UpdateLeftLean();
		if (params.add_right_lean == true) cuBuilding.UpdateRightLean();
		if (params.add_back_lean == true) cuBuilding.UpdateBackLean();
	};
	return {
		buildingTypeChange,
		buildingStyleChange,
		roofStyleChange
	};
};
const handleLeanRoofPitchHeight = ({ state, params, const_var, side, pitchKey, heightKey, widthKey, oldPitch, priceFlag, freeStandingFixedHeight = undefined }) => {
	const pitch = state.params[pitchKey];

	const straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, pitch, const_var.roofRegularDst);

	const isGable = state.params.leanStyle[side] === "gable";

	const calHeight = isGable ? state.params[heightKey] : state.params[heightKey] + Math.round((state.params[widthKey] * pitch) / 12) + straightRoofval;

	const leanRoofHeight = calHeight;

	const centerH = (state.params.p_w * state.params.p_r_p) / 24;

	const leanTotalH = state.params[heightKey] + (state.params[widthKey] * pitch) / 24;

	let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height;

	if (const_var.isForStandardBuilding && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers") && params.p_w <= isMaxHeight) {
		isMaxHeight = params.p_w;
	}

	const canIncreaseHeight =
		(!isGable && calHeight > state.params.p_h && calHeight <= isMaxHeight && (freeStandingFixedHeight === undefined || freeStandingFixedHeight > calHeight)) ||
		(isGable && (calHeight > state.params.p_h || leanTotalH > state.params.p_h + centerH) && (calHeight <= isMaxHeight || leanTotalH <= isMaxHeight + centerH));

	if (canIncreaseHeight) {
		if (!isGable) {
			state.params.p_h = state.params.p_h < leanRoofHeight ? leanRoofHeight : state.params.p_h;
		} else {
			if (params.p_h < leanRoofHeight || params.p_h + centerH < leanTotalH) {
				state.params.p_h = Math.max(leanRoofHeight, Math.ceil(leanTotalH - centerH));
			}
		}

		const_var.UpdatedPriceData.height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.common_height_changed = true;

		if (params.p_f_i) {
			const_var.UpdatedPriceData.insulation_price = undefined;
		}
	}

	const_var.UpdatedPriceData[priceFlag] = true;

	const exceedsHeight = (!isGable && calHeight > isMaxHeight) || (isGable && leanTotalH > isMaxHeight + centerH) || (freeStandingFixedHeight !== undefined && calHeight > freeStandingFixedHeight);

	if (exceedsHeight) {
		state.params[pitchKey] = oldPitch;
	}

	const exactVal = isGable ? Math.floor(state.params.p_h + centerH + state.params[heightKey] - leanTotalH) : Math.floor(state.params.p_h - (state.params[widthKey] * pitch) / 12);

	if (exactVal < 6 && state.params.p_h < isMaxHeight) {
		state.params.p_h += 1;
	}

	return {
		calHeight,
		leanRoofHeight,
		centerH,
		leanTotalH,
		isMaxHeight
	};
};
export const changeBuildingRoof = (state, event, value) => {
	const { params, const_var } = state;
	let previousRoofPitch = params.p_r_p;
	let filterData = [];
	if (
		((params.m_s_n == 3 || params.m_s_n == 9) && const_var.a_p_d_a.truss_name !== undefined && const_var.a_p_d_a.truss_name.length > 1) ||
		(const_var.a_p_d_a.truss_name !== undefined && const_var.a_p_d_a.truss_name.length > 1)
	) {
		filterData = const_var.a_p_d_a.truss_name.filter((data) => data.name.includes(params.trussType));
	}
	state.params.trussType = filterData.length > 0 ? filterData[0].name.replace(/[0-9]/g, "") : state.const_var.c_m_a[params.p_b_t].trussType[0].name.replace(/[0-9]/g, "");
	state.params.newtrussType = params.trussType;
	if (state.params.p_w > 100) {
		state.params.p_r_p = 4;
		state.params.b_l_t_r_pF = 3;
		state.params.b_l_t_r_p = 3;
		state.params.b_l_t_r_pR = 3;
		state.params.b_l_t_r_pB = 3;
		state.const_var.roofAction = false;
	} else {
		state.const_var.roofAction = true;
		if (value == "center") {
			state.params.b_r_p = event.replace("/", "");
			state.params.p_r_p = event.slice(0, 1);

			if (state.params.b_r_p != const_var.UpdatedPriceData.roof_pitch?.replace("/", "")) {
				const_var.UpdatedPriceData.roof_pitch_price_changed = true;
			}

			if (params.add_left_lean && state.params.p_r_p != state.params.b_l_t_r_p) {
				if (
					(state.params.leanStyle.left === "standard" && Math.floor(state.params.lean_p_h + (state.params.b_l_t_r_p / 12) * state.params.lean_p_w) == state.params.p_h) ||
					(state.params.leanStyle.left === "gable" && state.params.lean_p_h + ((state.params.b_l_t_r_p / 12) * state.params.lean_p_w) / 2 > state.params.p_h + ((state.params.p_w / 2) * state.params.p_r_p) / 12)
				)
					makeDimensionUpdateLeft(state);
			}
			if (params.add_right_lean && state.params.p_r_p != state.params.b_l_t_r_pR) {
				if (
					(state.params.leanStyle.right === "standard" && Math.floor(state.params.leanR_p_h + (state.params.b_l_t_r_pR / 12) * state.params.leanR_p_w) == state.params.p_h) ||
					(state.params.leanStyle.right === "gable" &&
						state.params.leanR_p_h + ((state.params.b_l_t_r_pR / 12) * state.params.leanR_p_w) / 2 > state.params.p_h + ((state.params.p_w / 2) * state.params.p_r_p) / 12)
				)
					makeDimensionUpdateRight(state);
			}
			if (params.add_front_lean && state.params.p_r_p != state.params.b_l_t_r_pF) {
				if (
					(state.params.leanStyle.front === "standard" && Math.floor(state.params.leanF_p_h + (state.params.b_l_t_r_pF / 12) * state.params.leanF_p_w) == state.params.p_h) ||
					(state.params.leanStyle.front === "gable" &&
						state.params.leanF_p_h + ((state.params.b_l_t_r_pF / 12) * state.params.leanF_p_w) / 2 > state.params.p_h + ((state.params.p_w / 2) * state.params.p_r_p) / 12)
				)
					makeDimensionUpdateFront(state);
			}
			if (params.add_back_lean && state.params.p_r_p != state.params.b_l_t_r_pB) {
				if (
					(state.params.leanStyle.back === "standard" && Math.floor(state.params.leanB_p_h + (state.params.b_l_t_r_pB / 12) * state.params.leanB_p_w) == state.params.p_h) ||
					(state.params.leanStyle.back === "gable" &&
						state.params.leanB_p_h + ((state.params.b_l_t_r_pB / 12) * state.params.leanB_p_w) / 2 > state.params.p_h + ((state.params.p_w / 2) * state.params.p_r_p) / 12)
				)
					makeDimensionUpdateBack(state);
			}

			checkRoofPitch(previousRoofPitch);

			cuBuilding.BuildingUpdate(true, "");
			if (params.add_front_lean) cuBuilding.UpdateFrontLean();
			if (params.add_left_lean) cuBuilding.UpdateLeftLean();
			if (params.add_right_lean) cuBuilding.UpdateRightLean();
			if (params.add_back_lean) cuBuilding.UpdateBackLean();
			if (params.checkeditName != true) {
				let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
				params.other_building_type_name = newVal;
				if (const_var.post_data.building != undefined) {
					const_var.post_data.building.other_building_type_name = params.other_building_type_name;
					const_var.post_data.building.name = params.other_building_type_name;
				}
			}
			const_var.UpdatedPriceData.insulation_price = undefined;
			const_var.UpdatedPriceData.utility_price_changed = true;
			const_var.UpdatedPriceData.front_utility_price_changed = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			cuBuilding.cP();
			updateTemplateWidthF();
			updateTemplateWidthB();
			updateTemplateWidthL();
			updateTemplateWidthR();
			centerBuildingsWallOptionsHelpers.syncCenterWallOptions(state);
		}

		if (value == "front") {
			let b_l_t_r_pF_old = params.b_l_t_r_pF;
			state.params.b_l_t_r_pF = parseInt(event);
			if (state.params.add_front_lean == true) {
				handleLeanRoofPitchHeight({
					state,
					params,
					const_var,
					side: "front",
					pitchKey: "b_l_t_r_pF",
					heightKey: "leanF_p_h",
					widthKey: "leanF_p_w",
					oldPitch: b_l_t_r_pF_old,
					priceFlag: "front_lean_height_price_changed"
				});
			}
			var dataW = Math.floor(((state.params.p_h - state.params.leanF_p_h) * 100) / ((state.params.b_l_t_r_pF / 12) * 100));
			var newDataW = parseInt(dataW) >= 24 ? 24 : parseInt(dataW);
			var dataH = Math.floor(state.params.p_h - (state.params.leanF_p_w * state.params.b_l_t_r_pF) / 12);

			checkLegsDataAccordingtoResponse(const_var?.ConditionArr[params.p_b_t][params.p_r_s], "dimension");

			if (state.params.leanStyle.front !== "gable" && (dataH < 6 || newDataW < 6)) {
				if (newDataW < 6) {
					state.params.leanF_p_w = 6;
				}
				if (dataH < state.const_var.b_m_i_hlean) {
					state.params.leanF_p_h = state.const_var.b_m_i_hlean;
				}
				state.params.b_l_t_r_pF = "2";
			}

			if (state.params.add_right_front_lean_porch == true && state.params.b_l_t_r_pF != state.params.b_l_t_r_pR) {
				state.params.add_right_front_lean_porch = false;
			}

			if (state.params.add_left_front_lean_porch == true && state.params.b_l_t_r_pF != state.params.b_l_t_r_p) {
				state.params.add_left_front_lean_porch = false;
			}

			if (params.leanStyle.front == "gable") {
				checkRoofPitch(b_l_t_r_pF_old, "front", const_var.leanGetDataFront);
			}

			makeDimensionUpdateFront(state);
			centerBuildingsWallOptionsHelpers.syncCenterWallOptions(state);
			leanToWallOptionHelpers.syncLeanToWallOptions(state);
			cuBuilding.BuildingUpdate(true, "");
			cuBuilding.UpdateFrontLean();

			const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;

			if (params.checkeditName != true) {
				let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
				params.other_building_type_name = newVal;
				if (const_var.post_data.building != undefined) {
					const_var.post_data.building.other_building_type_name = params.other_building_type_name;
					const_var.post_data.building.name = params.other_building_type_name;
				}
			}
		}
		if (value == "left") {
			let b_l_t_r_p_old = params.b_l_t_r_p;
			state.params.b_l_t_r_p = parseInt(event);
			if (state.params.add_left_lean == true) {
				handleLeanRoofPitchHeight({
					state,
					params,
					const_var,
					side: "left",
					pitchKey: "b_l_t_r_p",
					heightKey: "lean_p_h",
					widthKey: "lean_p_w",
					oldPitch: b_l_t_r_p_old,
					priceFlag: "left_lean_height_price_changed"
				});
			}
			var dataW = Math.floor(((state.params.p_h - state.params.lean_p_h) * 100) / ((state.params.b_l_t_r_p / 12) * 100));
			var newDataW = parseInt(dataW) >= 24 ? 24 : parseInt(dataW);
			var dataH = Math.floor(state.params.p_h - (state.params.lean_p_w * state.params.b_l_t_r_p) / 12);
			let minWidthL = 6;
			let roofDatanew = const_var.roof_style_Barn;
			if (const_var.roof_style_Barn_with_centerbuilding[params.p_b_t] != undefined) {
				roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
			}
			roofDatanew.map((val, i) => {
				if (params.p_r_s == val.roof_id) {
					minWidthL = val.min_width;
					const_var.leanDimension = val;
				}
			});

			checkLegsDataAccordingtoResponse(const_var?.ConditionArr[params.p_b_t][params.p_r_s], "dimension");

			if (state.params.leanStyle.left !== "gable" && (dataH < 6 || newDataW < minWidthL)) {
				if (newDataW < minWidthL) {
					state.params.lean_p_w = minWidthL;
				}
				if (dataH < state.const_var.b_m_i_hlean) {
					state.params.lean_p_h = state.const_var.b_m_i_hlean;
				}
				state.params.b_l_t_r_p = "2";
			}

			if (state.params.add_left_front_lean_porch != false && params.b_l_t_r_p != params.b_l_t_r_pF) {
				state.params.add_left_front_lean_porch = false;
				cuBuilding.UpdateFrontLean();
			}

			if (state.params.add_left_back_lean_porch != false && params.b_l_t_r_p != params.b_l_t_r_pB) {
				state.params.add_left_back_lean_porch = false;
				cuBuilding.UpdateBackLean();
			}

			if (state.params.add_left_front_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
				state.params.add_right_front_lean_porch = false;
			}

			if (state.params.add_left_back_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
				state.params.add_right_back_lean_porch = false;
			}

			if (params.leanStyle.left == "gable") {
				checkRoofPitch(b_l_t_r_p_old, "left", const_var.leanGetDataLeft);
			}
			makeDimensionUpdateLeft(state);
			centerBuildingsWallOptionsHelpers.syncCenterWallOptions(state);
			leanToWallOptionHelpers.syncLeanToWallOptions(state);
			cuBuilding.BuildingUpdate(true, "");
			cuBuilding.UpdateLeftLean();
			const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;

			if (params.checkeditName != true) {
				let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
				params.other_building_type_name = newVal;
				if (const_var.post_data.building != undefined) {
					const_var.post_data.building.other_building_type_name = params.other_building_type_name;
					const_var.post_data.building.name = params.other_building_type_name;
				}
			}
		}
		if (value == "right") {
			let b_l_t_r_pR_old = params.b_l_t_r_pR;
			state.params.b_l_t_r_pR = parseInt(event);

			if (state.params.add_right_lean == true) {
				let freeStandingFixedHeight;

				if (params.singleSlope == true) {
					if (
						const_var.c_m_a[params.p_b_t] != undefined &&
						const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined &&
						const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0 &&
						state.const_var.c_m_a[params.p_b_t].fixed_new_leg_width[0][params.p_w] !== undefined
					) {
						freeStandingFixedHeight = state.const_var.c_m_a[params.p_b_t].fixed_new_leg_width[0][params.p_w].max_height;
					}
				}

				handleLeanRoofPitchHeight({
					state,
					params,
					const_var,
					side: "right",
					pitchKey: "b_l_t_r_pR",
					heightKey: "leanR_p_h",
					widthKey: "leanR_p_w",
					oldPitch: b_l_t_r_pR_old,
					priceFlag: "right_lean_height_price_changed",
					freeStandingFixedHeight
				});
			}
			var dataW = Math.floor(((state.params.p_h - state.params.leanR_p_h) * 100) / ((state.params.b_l_t_r_pR / 12) * 100));

			var newDataW = parseInt(dataW) >= 24 ? 24 : parseInt(dataW);
			var dataH = Math.floor(state.params.p_h - (state.params.leanR_p_w * state.params.b_l_t_r_pR) / 12);
			let minWidthR = 6;
			let roofDatanew = const_var.roof_style_Barn;
			if (const_var.roof_style_Barn_with_centerbuilding[params.p_b_t] != undefined) {
				roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
			}
			roofDatanew.map((val, i) => {
				if (params.p_r_s == val.roof_id) {
					minWidthR = val.min_width;
					const_var.leanDimension = val;
				}
			});
			checkLegsDataAccordingtoResponse(const_var?.ConditionArr[params.p_b_t][params.p_r_s], "dimension");
			if (state.params.leanStyle.right !== "gable" && (dataH < 6 || newDataW < minWidthR)) {
				if (newDataW < minWidthR) {
					state.params.leanR_p_w = minWidthR;
				}
				if (dataH < state.const_var.b_m_i_hlean) {
					state.params.leanR_p_h = state.const_var.b_m_i_hlean;
				}
				state.params.b_l_t_r_pR = "2";
			}

			if (state.params.add_right_front_lean_porch != false && params.b_l_t_r_pR != params.b_l_t_r_pF) {
				state.params.add_right_front_lean_porch = false;
				cuBuilding.UpdateFrontLean();
			}

			if (state.params.add_right_back_lean_porch != false && params.b_l_t_r_pR != params.b_l_t_r_pB) {
				state.params.add_right_back_lean_porch = false;
				cuBuilding.UpdateBackLean();
			}

			if (state.params.add_right_front_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
				state.params.add_left_front_lean_porch = false;
			}

			if (state.params.add_right_back_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR) {
				state.params.add_left_back_lean_porch = false;
			}
			if (params.leanStyle.right == "gable") {
				checkRoofPitch(b_l_t_r_pR_old, "right", const_var.leanGetDataRight);
			}
			makeDimensionUpdateRight(state);
			centerBuildingsWallOptionsHelpers.syncCenterWallOptions(state);
			leanToWallOptionHelpers.syncLeanToWallOptions(state);
			cuBuilding.BuildingUpdate(true, "");
			cuBuilding.UpdateRightLean();
			const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;

			if (params.checkeditName != true) {
				let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
				params.other_building_type_name = newVal;
				if (const_var.post_data.building != undefined) {
					const_var.post_data.building.other_building_type_name = params.other_building_type_name;
					const_var.post_data.building.name = params.other_building_type_name;
				}
			}
		}
		if (value == "back") {
			let b_l_t_r_pB_old = params.b_l_t_r_pB;
			state.params.b_l_t_r_pB = parseInt(event);
			if (state.params.add_back_lean == true) {
				handleLeanRoofPitchHeight({
					state,
					params,
					const_var,
					side: "back",
					pitchKey: "b_l_t_r_pB",
					heightKey: "leanB_p_h",
					widthKey: "leanB_p_w",
					oldPitch: b_l_t_r_pB_old,
					priceFlag: "back_lean_height_price_changed"
				});
			}
			var dataW = Math.floor(((state.params.p_h - state.params.leanB_p_h) * 100) / ((state.params.b_l_t_r_pB / 12) * 100));
			var newDataW = parseInt(dataW) >= 24 ? 24 : parseInt(dataW);
			var dataH = Math.floor(state.params.p_h - (state.params.leanB_p_w * state.params.b_l_t_r_pB) / 12);

			checkLegsDataAccordingtoResponse(const_var?.ConditionArr[params.p_b_t][params.p_r_s], "dimension");

			if (state.params.leanStyle.back !== "gable" && (dataH < 6 || newDataW < 6)) {
				if (newDataW < 6) {
					state.params.leanB_p_w = 6;
				}
				if (dataH < state.const_var.b_m_i_hlean) {
					state.params.leanB_p_h = state.const_var.b_m_i_hlean;
				}
				state.params.b_l_t_r_pB = "2";
			}
			if (state.params.add_right_back_lean_porch == true && state.params.b_l_t_r_pB != state.params.b_l_t_r_pR) {
				state.params.add_right_back_lean_porch = false;
				cuBuilding.UpdateRightLean();
			}

			if (state.params.add_left_back_lean_porch == true && state.params.b_l_t_r_pB != state.params.b_l_t_r_p) {
				state.params.add_left_back_lean_porch = false;
				cuBuilding.UpdateLeftLean();
			}

			if (params.leanStyle.back == "gable") {
				checkRoofPitch(b_l_t_r_pB_old, "back", const_var.leanGetDataBack);
			}
			makeDimensionUpdateBack(state);
			centerBuildingsWallOptionsHelpers.syncCenterWallOptions(state);
			leanToWallOptionHelpers.syncLeanToWallOptions(state);
			cuBuilding.BuildingUpdate(true, "");
			cuBuilding.UpdateBackLean("roof");
			const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;

			if (params.checkeditName != true) {
				let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
				params.other_building_type_name = newVal;
				if (const_var.post_data.building != undefined) {
					const_var.post_data.building.other_building_type_name = params.other_building_type_name;
					const_var.post_data.building.name = params.other_building_type_name;
				}
			}
		}
		if (value == "front" || value == "left" || value == "right" || value == "back") {
			if (const_var.callMesure) {
			}
		}
		if (const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" && const_var.loginSession == false) {
			utils.onWidthHeightChange(params.p_w, params.p_h);
		}
	}
	if (params.cupola) handlCupolaPositionOnDimensionChange("roofPitch");

	if (
		params.singleSlope != true &&
		((const_var.crmSetting.is_Edit != true && params.m_s_n == 153 && (params.p_r_s == 2 || params.p_r_s == 1) && params.p_h > 10) ||
			(const_var.crmSetting.is_Edit == true && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && const_var.editAPIDataByResponse != undefined && const_var.editAPIDataByResponse.data != undefined))
	) {
		if (const_var.insulationPriceJson?.insulation_wall != undefined && Object.keys(const_var.insulationPriceJson.insulation_wall).length > 0) {
			const_var.insulationPriceJson.insulation_wall = {};
		}

		params.insulation.center.insulationId = 0;

		params.insulation.center.isCheked = false;

		params.insulation.center.showInsulationOptions = false;
		params.insulation.center.roofOnly = params.insulation.center.insulationId !== 0 ? true : false;
		params.insulation.center.fullBuilding = params.insulation.center.roofOnly ? false : params.insulation.center.fullBuilding;
		params.insulation.center.custom = params.insulation.center.roofOnly || params.insulation.center.fullBuilding ? false : params.insulation.center.custom;

		const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;

		if (params.add_front_lean == true && params.insulation["frontLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.leanF_p_h > 10) {
			params.insulation["frontLean"].isCheked = false;
			params.insulation["frontLean"].insulationId = 0;

			params.insulation["frontLean"].showInsulationOptions = false;
			params.insulation["frontLean"].roofOnly = params.insulation["frontLean"].insulationId !== 0 ? true : false;
			params.insulation["frontLean"].fullBuilding = params.insulation["frontLean"].roofOnly ? false : params.insulation["frontLean"].fullBuilding;
			params.insulation["frontLean"].custom = params.insulation["frontLean"].roofOnly || params.insulation["frontLean"].fullBuilding ? false : params.insulation["frontLean"].custom;
		}

		if (params.add_back_lean == true && params.insulation["backLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.leanB_p_h > 10) {
			params.insulation["backLean"].isCheked = false;
			params.insulation["backLean"].insulationId = 0;

			params.insulation["backLean"].showInsulationOptions = false;
			params.insulation["backLean"].roofOnly = params.insulation["backLean"].insulationId !== 0 ? true : false;
			params.insulation["backLean"].fullBuilding = params.insulation["backLean"].roofOnly ? false : params.insulation["backLean"].fullBuilding;
			params.insulation["backLean"].custom = params.insulation["backLean"].roofOnly || params.insulation["backLean"].fullBuilding ? false : params.insulation["backLean"].custom;
		}

		// ########### Right lean ##############
		if (params.add_right_lean == true && params.insulation["rightLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.leanR_p_h > 10) {
			params.insulation["rightLean"].isCheked = false;
			params.insulation["rightLean"].insulationId = 0;

			params.insulation["rightLean"].showInsulationOptions = false;
			params.insulation["rightLean"].roofOnly = params.insulation["rightLean"].insulationId !== 0 ? true : false;
			params.insulation["rightLean"].fullBuilding = params.insulation["rightLean"].roofOnly ? false : params.insulation["rightLean"].fullBuilding;
			params.insulation["rightLean"].custom = params.insulation["rightLean"].roofOnly || params.insulation["rightLean"].fullBuilding ? false : params.insulation["rightLean"].custom;
		}

		// ########### Left lean ##############

		if (params.add_left_lean == true && params.insulation["leftLean"] != undefined && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && params.lean_p_h > 10) {
			params.insulation["leftLean"].isCheked = false;
			params.insulation["leftLean"].insulationId = 0;

			params.insulation["leftLean"].showInsulationOptions = false;
			params.insulation["leftLean"].roofOnly = params.insulation["leftLean"].insulationId !== 0 ? true : false;
			params.insulation["leftLean"].fullBuilding = params.insulation["leftLean"].roofOnly ? false : params.insulation["leftLean"].fullBuilding;
			params.insulation["leftLean"].custom = params.insulation["leftLean"].roofOnly || params.insulation["leftLean"].fullBuilding ? false : params.insulation["leftLean"].custom;
		}
	}

	// ################# lower height of free standing building ###############
	let lowerHeightOfFreeStanding =
		const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
			? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
			: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12);

	// ################# Free standing building check : Heritage Manufacture #################
	if (
		params.singleSlope == true &&
		((const_var.crmSetting.is_Edit != true && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && lowerHeightOfFreeStanding > 10) ||
			(const_var.crmSetting.is_Edit == true && params.m_s_n == 153 && const_var.editAPIDataByResponse != undefined && const_var.editAPIDataByResponse.data != undefined))
	) {
		if (params.p_f_i == false && params.p_r_o == false && params.p_c_i == false) {
			params.p_i_o = 0;
			params.insulation.center.insulationId = 0;
			params.p_c_i = false;
			params.p_f_i = false;
			params.p_r_o = false;

			params.insulation.center.isCheked = false;

			params.insulation.center.showInsulationOptions = false;
			params.insulation.center.roofOnly = params.insulation.center.insulationId !== 0 ? true : false;
			params.insulation.center.fullBuilding = params.insulation.center.roofOnly ? false : params.insulation.center.fullBuilding;
			params.insulation.center.custom = params.insulation.center.roofOnly || params.insulation.center.fullBuilding ? false : params.insulation.center.custom;

			const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
		}
	}
};

export default createBuildingStyleChanges;
